import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProcedureService } from '../../../services/procedure.service';
import { PlansProcedure } from '../../../dto/procedure.dto';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaskModule } from 'ngx-mask';

@Component({
  template: `
    <h1 mat-dialog-title>Criar Novo Procedimento</h1>

    <form [formGroup]="form" (ngSubmit)="create()" *ngIf="form">
      <div mat-dialog-content>
        <mat-form-field appearance="outline">
          <mat-label>Nome do Procedimento</mat-label>
          <input matInput formControlName="name" placeholder="Digite o nome do plano">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Valor do Procedimento</mat-label>
          <input 
            matInput 
            formControlName="price" 
            placeholder="Digite o valor" 
            [mask]="'separator.0'" 
            thousandSeparator="." 
            decimalMarker=","
          >
          <mat-error *ngIf="form.get('price')?.hasError('min')">
            O valor mínimo é R$ 1,00.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" >
          <mat-label>Valor Repassado</mat-label>
          <input 
            matInput 
            formControlName="transferAmmount" 
            placeholder="Digite o repasse" 
            [mask]="'separator.0'" 
            thousandSeparator="." 
            decimalMarker=","
          >
          <mat-error *ngIf="form.get('transferAmmount')?.hasError('min')">
            O valor mínimo é R$ 1,00.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Planos</mat-label>
          <mat-select formControlName="planId">
            <mat-option *ngFor="let p of plansList" [value]="p.id">{{ p.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-dialog-actions align="end">
        <button mat-button (click)="deny()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Criar</button>
      </mat-dialog-actions>
    </form>
  `,
  styles: [],


})
export class CreateProcedureModalComponent implements OnInit {
  form: FormGroup;
  active: number | undefined;
  plansList: PlansProcedure[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreateProcedureModalComponent>,
    private formBuild: FormBuilder,
    private plans: ProcedureService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuild.group({
      name: ['', Validators.required],
      price: ['', [Validators.required, Validators.min(1)]],
      transferAmmount: ['', [Validators.required, Validators.min(1)]],
      planId: ['', Validators.required]
    });

    this.getAllActivePlans();
  }

  deny():void {
    this.dialogRef.close();
  }

  create(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    } else {
      console.warn('Formulário inválido');
    }
  }

  getAllActivePlans(): void {
    this.plans.getAllActivePlans().subscribe({
      next: data => this.plansList = data,
      error: err => console.log(err)
    })
  }
}
